export default __webpack_public_path__ + "static/media/FrozenABC_06.30c13d8e.png";